/** Russian messages for Portal and academy sign-in flows. */

export function translatePortalAuthError(message) {
    if (!message) return 'Не удалось выполнить операцию. Попробуйте ещё раз.';
    const m = String(message);

    if (/invalid login credentials/i.test(m)) return 'Неверный email или пароль.';
    if (/email not confirmed/i.test(m)) {
        return 'Подтвердите email по ссылке из письма, затем войдите снова.';
    }
    if (/user already registered|already been registered/i.test(m)) {
        return 'Этот email уже зарегистрирован. Войдите в аккаунт.';
    }
    if (/password should be at least|at least 8/i.test(m)) {
        return 'Пароль должен быть не короче 8 символов.';
    }
    if (/unable to validate email|invalid email/i.test(m)) {
        return 'Укажите корректный адрес email.';
    }
    if (/signup is disabled|signups not allowed/i.test(m)) {
        return 'Регистрация временно недоступна. Попробуйте позже.';
    }
    if (/too many requests|rate limit/i.test(m)) {
        return 'Слишком много попыток. Подождите немного и попробуйте снова.';
    }

    return m;
}

export function translateAcademyLoginError(message, code) {
    if (code === 'USE_PORTAL_LOGIN') {
        return 'Этот аккаунт в Портале. Войдите через страницу Портала.';
    }
    if (code === 'ACCOUNT_DEACTIVATED') {
        return message || 'Аккаунт деактивирован. Свяжитесь с преподавателем.';
    }
    return translatePortalAuthError(message);
}
